// config.js
// API base URL, picked automatically:
//   npm start      (NODE_ENV=development) -> local server
//   npm run build  (NODE_ENV=production)  -> production API
// Override either one by setting REACT_APP_API_URL, e.g.
//   REACT_APP_API_URL=https://api.dmyor.com npm run build
const DEV_API = "http://localhost:5173";
const PROD_API = "https://prod.dmyor.com";

const config = {
  apiUrl:
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === "production" ? PROD_API : DEV_API),
};

export default config;
